import { useState } from 'react'
import { useWindowSize } from '../../../../../core/hooks/common/useWindowSize'
import { useAclContext } from '../../../../../core/contexts/acl'
import { TABLET_SIZE } from '../../../../../core/constants/common'
import { useGetDueTransactions } from '../../../../../core/services/react-query/report/banking'
import {
	CacheKeys,
	dueTransactionOptions,
	dueTransactionSortOptions,
} from '../../../../../core/constants/filter'
import FilterLayout from '../../../../layout/filter/FilterLayout'
import DueTransactionTable from './DueTransactionTable'
import RDueTransactionTable from '../../../../responsive/main/reports/bank-transactions/RDueTransactionTable'

const DuePaymentTransactions = () => {
	const { width } = useWindowSize()
	const [withdraws, setWithdraws] = useState({ data: null, loading: true })

	const { permissions } = useAclContext()
	const hasDownload = permissions?.export?.write

	const onQuerySuccess = (res) => {
		setWithdraws(res)
	}

	const Component = width > TABLET_SIZE ? DueTransactionTable : RDueTransactionTable

	return (
		<FilterLayout
			query={useGetDueTransactions}
			onQuerySuccess={onQuerySuccess}
			options={dueTransactionOptions}
			cache={CacheKeys.DUE_TRANSACTIONS}
			hasDownload={hasDownload}
			sortOptions={dueTransactionSortOptions}
		>
			{width && <Component data={withdraws} />}
		</FilterLayout>
	)
}

export default DuePaymentTransactions
